var _rect, _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDollar2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 10,
    fill: "url(#paint0_linear_1326_1084)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.25 46.5333H42.3333C43.4167 46.5333 44.3167 45.5667 44.3167 44.4C44.3167 42.95 43.8 42.6667 42.95 42.3667L41.2667 41.7833V46.5333H41.25Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9508 23.1667C30.7508 23.2 23.3008 30.6833 23.3341 39.8833C23.3674 49.0833 30.8508 56.5333 40.0508 56.5C49.2508 56.4667 56.7008 48.9833 56.6674 39.7833C56.6341 30.5833 49.1508 23.15 39.9508 23.1667ZM43.7674 40C45.0674 40.45 46.8174 41.4167 46.8174 44.4C46.8174 46.9667 44.8008 49.0333 42.3341 49.0333H41.2508V50C41.2508 50.6833 40.6841 51.25 40.0008 51.25C39.3174 51.25 38.7508 50.6833 38.7508 50V49.0333H38.1508C35.4174 49.0333 33.2008 46.7333 33.2008 43.9C33.2008 43.2167 33.7674 42.65 34.4508 42.65C35.1341 42.65 35.7008 43.2167 35.7008 43.9C35.7008 45.35 36.8008 46.5333 38.1508 46.5333H38.7508V40.9L36.2341 40C34.9341 39.55 33.1841 38.5833 33.1841 35.6C33.1841 33.0333 35.2008 30.9667 37.6674 30.9667H38.7508V30C38.7508 29.3167 39.3174 28.75 40.0008 28.75C40.6841 28.75 41.2508 29.3167 41.2508 30V30.9667H41.8508C44.5841 30.9667 46.8008 33.2667 46.8008 36.1C46.8008 36.7833 46.2341 37.35 45.5508 37.35C44.8674 37.35 44.3008 36.7833 44.3008 36.1C44.3008 34.65 43.2008 33.4667 41.8508 33.4667H41.2508V39.1L43.7674 40Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6992 35.6167C35.6992 37.0667 36.2159 37.35 37.0659 37.65L38.7492 38.2333V33.4667H37.6659C36.5826 33.4667 35.6992 34.4333 35.6992 35.6167Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1326_1084",
    x1: 16.7273,
    y1: 85.8182,
    x2: 54.6517,
    y2: 9.39854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544463"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.508486,
    stopColor: "#9F533B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6403"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDollar2);
export default __webpack_public_path__ + "static/media/icon_dollar_2.4dbed234a6e6a48ea2aa100f1eaa154f.svg";
export { ForwardRef as ReactComponent };